import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductModel } from '../models/product.model';
import { MathService } from '../services/math/math.service';

@Pipe({ name: 'sumUpProduct',pure:false })
export class SumUpProductPipe implements PipeTransform {
  constructor(private mathService:MathService, private currencyPipe:CurrencyPipe, private translateService: TranslateService){

  }
  transform(product: ProductModel, priceMode: string, currency: string, countryCode: string, status? : string) {
    let display:string = '';
    const totals = this.mathService.calculateProductTotalsAmount(product, countryCode);
    const price = priceMode === 'VATExcluded' ? totals?.VATExcluded : totals?.VATIncluded;
    display += status=='estimated'?'±':''
    display += this.currencyPipe.transform(price,currency.toUpperCase());
    display += priceMode == 'VATExcluded' ? (' '+this.translateService.instant('tax.VATExcludedShort')) : '';
    return display;
  }
}